<script lang="ts">
    import { getOperation } from "../../api"
    import { newNotification, pendingOverlayOperation } from "../../store"
    import { navigateTo, requireLogin } from "../../helper"
    import { _ } from "svelte-i18n"
    import { get } from "svelte/store"
    import MiniLoader from "../widgets/MiniLoader.svelte"

    export let opNumber: string
    export let lang = "de"

    let handled = false
    let loading = true

    $: if (opNumber && !handled) {
        handled = true
        handle()
    }

    async function handle() {
        // login redirect (redirectTo behält /de/op/:opNumber) — bei fehlendem Login
        // leitet requireLogin selbst weiter, dann hier abbrechen
        const l = await requireLogin()
        if (!l) return

        const number = parseInt(opNumber, 10)
        if (isNaN(number)) {
            notFound(opNumber)
            return
        }

        try {
            const r = await getOperation("operation", { number }, 1, 0, "list")
            const op = r.data?.[0]
            if (op) {
                // Operations.svelte leert beim Mount die overlayTabs — das Overlay
                // darf daher erst NACH dem Locations-Wechsel geöffnet werden.
                // -> Op als pending ablegen, Operations.svelte öffnet es selbst.
                pendingOverlayOperation.set(op)
                navigateTo(`/operations?type=${op.type}`, { replace: true }, lang)
            } else {
                notFound(String(number))
            }
        } catch (e) {
            notFound(String(number))
        } finally {
            loading = false
        }
    }

    function notFound(displayNumber: string = opNumber) {
        // displayNumber kommt aus Route-Param -> für {@html n.html} escapen
        const safe = String(displayNumber).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        newNotification({
            class: "error",
            html: get(_)("operations.operationNotFound", { values: { number: safe } }),
        })
        navigateTo(`/operations`, { replace: true }, lang)
    }
</script>

<section class="section_padding" data-lang="{lang}">
    <div class="container_wide">
        {#if loading}
            <div class="centerbutton">
                <MiniLoader />
            </div>
        {/if}
    </div>
</section>